import { EnumFormTypes } from '@blade-sxp/device-management/interfaces/form';
import { getLangTxt, langTextInit } from '@blade/common/utils/echartUtils';
import lang from '@blade-sxp/device-management/lang/index';
langTextInit(lang);
export const getPlatformItemConfig = (type) => {
    const baseConfig = {
        disabled: false,
        isHide: false,
    };
    const btnConfig = {
        disabled: false,
        isHide: false,
    };
    const ipConfig = {
        disabled: false,
    };
    const inputNumConfig = {
        disabled: false,
        isHide: false,
    };
    const passwordConfig = {
        // disabled: false,
        isHide: false,
        isPassword: true,
    };
    const localFlagCOnfig = {
        isHide: true,
    };
    const codeConfig = {
        disabled: false,
    };
    switch (type) {
        case 'add':
            baseConfig.disabled = false;
            inputNumConfig.disabled = false;
            btnConfig.disabled = false;
            passwordConfig.isHide = false;
            localFlagCOnfig.isHide = true;
            codeConfig.disabled = false;
            // ipConfig.disabled = false;
            break;
        case 'edit':
            baseConfig.disabled = false;
            // ipConfig.disabled = true;
            inputNumConfig.disabled = false;
            localFlagCOnfig.isHide = true;
            btnConfig.disabled = false;
            passwordConfig.isHide = false;
            codeConfig.disabled = true;
            break;
        case 'view':
            baseConfig.disabled = false;
            inputNumConfig.disabled = false;
            localFlagCOnfig.isHide = true;
            btnConfig.isHide = false;
            passwordConfig.isHide = false;
            codeConfig.disabled = true;
            // ipConfig.disabled = true;
            break;
        default:
    }
    const maxlength = 20;
    const config = {
        sort: ['name', 'localFlag', 'code', 'ip', 'port', 'userName', 'password', 'heartInterval', 'maxBeats'],
        btns: [
            {
                ...btnConfig,
                label: getLangTxt('removebtn'),
                btnType: 'defalut',
                isSure: false,
                key: 'cancel',
            },
            {
                ...btnConfig,
                label: getLangTxt('save'),
                btnType: 'defalut',
                isSure: true,
                key: 'save',
            }
        ],
        option: {
            name: {
                ...baseConfig,
                label: getLangTxt('platName'),
                placeholder: getLangTxt('platNamePlaceholder'),
                maxlength: maxlength,
                formType: EnumFormTypes.input,
                clearable: false,
            },
            localFlag: {
                ...baseConfig,
                ...localFlagCOnfig,
                label: getLangTxt('isPlatLocal'),
                defaultValue: false,
                formType: EnumFormTypes.audio,
                audios: [
                    {
                        ...baseConfig,
                        label: getLangTxt('yes'),
                        value: true,
                    },
                    {
                        ...baseConfig,
                        label: getLangTxt('no'),
                        value: false,
                    }
                ]
            },
            code: {
                ...baseConfig,
                ...codeConfig,
                label: getLangTxt('platCode'),
                placeholder: getLangTxt('codePlaceholder'),
                maxlength: maxlength,
                formType: EnumFormTypes.input,
                clearable: false,
            },
            ip: {
                ...baseConfig,
                maxlength: maxlength,
                label: getLangTxt('platIP'),
                // placeholder: getLangTxt('ipPlaceholder'),
                placeholder: '192.168.1.1',
                formType: EnumFormTypes.input,
                clearable: false,
            },
            port: {
                ...baseConfig,
                label: getLangTxt('platPort'),
                placeholder: getLangTxt('portPlaceholder'),
                formType: EnumFormTypes.input,
                maxlength: 5,
                clearable: false,
            },
            userName: {
                ...baseConfig,
                label: getLangTxt('platUserName'),
                placeholder: getLangTxt('userNamePlaceholder'),
                formType: EnumFormTypes.input,
                maxlength: 50,
                clearable: false,
            },
            password: {
                ...baseConfig,
                label: getLangTxt('platPassword'),
                maxlength: 50,
                placeholder: getLangTxt('passwordPlaceholder'),
                formType: EnumFormTypes.input,
                clearable: false,
                ...passwordConfig,
            },
            heartInterval: {
                ...inputNumConfig,
                label: getLangTxt('platHeartInterval'),
                placeholder: getLangTxt('heartIntervalPlaceholder'),
                defaultValue: 60,
                formType: EnumFormTypes.input,
                append: getLangTxt('seconds'),
                clearable: false,
                maxlength: 5,
            },
            maxBeats: {
                ...inputNumConfig,
                label: getLangTxt('platMaxBeats'),
                placeholder: getLangTxt('maxBeatsPlaceholder'),
                defaultValue: 3,
                formType: EnumFormTypes.input,
                append: getLangTxt('times'),
                clearable: false,
                maxlength: 5,
            },
        }
    };
    return config;
};
export const getPlatformDeviceConfig = (type) => {
    const baseConfig = {
        disabled: false,
        isHide: false,
    };
    const btnConfig = {
        disabled: false,
        isHide: false,
    };
    const deviceNameConfig = {
        isHide: true,
        disabled: true,
    };
    const inputNumConfig = {
        disabled: false,
        isHide: false,
    };
    const platformConfig = {
        disabled: false,
    };
    const deviceListConfig = {
        disabled: false,
        isHide: false,
    };
    const groupNameConfig = {
        disabled: false,
    };
    const notesConfig = {
        disabled: false,
    };
    switch (type) {
        case 'add':
            baseConfig.disabled = false;
            inputNumConfig.disabled = false;
            btnConfig.disabled = false;
            platformConfig.disabled = false;
            deviceListConfig.disabled = false;
            deviceListConfig.isHide = false;
            deviceNameConfig.isHide = true;
            deviceNameConfig.disabled = true;
            groupNameConfig.disabled = false;
            notesConfig.disabled = false;
            break;
        case 'edit':
            baseConfig.disabled = false;
            inputNumConfig.disabled = false;
            btnConfig.disabled = false;
            platformConfig.disabled = true;
            deviceListConfig.disabled = true;
            deviceListConfig.isHide = true;
            deviceNameConfig.isHide = true;
            deviceNameConfig.disabled = true;
            groupNameConfig.disabled = false;
            notesConfig.disabled = false;
            break;
        case 'view':
            baseConfig.disabled = false;
            inputNumConfig.disabled = false;
            btnConfig.isHide = false;
            platformConfig.disabled = true;
            deviceListConfig.disabled = true;
            deviceListConfig.isHide = true;
            deviceNameConfig.isHide = true;
            deviceNameConfig.disabled = true;
            groupNameConfig.disabled = true;
            notesConfig.disabled = true;
            break;
        default:
    }
    const maxlength = 20;
    const config = {
        sort: ['accessPlatform', 'deviceName', 'groupName', 'deviceList', 'notes'],
        btns: [],
        option: {
            accessPlatform: {
                ...baseConfig,
                ...platformConfig,
                label: getLangTxt('accessPlatform'),
                placeholder: getLangTxt('accessPlatformPlaceholder'),
                formType: EnumFormTypes.select,
                options: [],
                defaultValue: '',
            },
            deviceName: {
                ...baseConfig,
                ...deviceNameConfig,
                formType: EnumFormTypes.input,
                label: getLangTxt(''),
                placeholder: getLangTxt(''),
                defaultValue: ''
            },
            groupName: {
                ...baseConfig,
                ...groupNameConfig,
                label: getLangTxt('groupName'),
                placeholder: getLangTxt('groupNamePlaceholder'),
                options: [],
                props: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                    checkStrictly: true,
                    emitPath: false, // 只返回该节点的值
                },
                formType: EnumFormTypes.cascader,
                defaultValue: '',
            },
            deviceList: {
                ...deviceListConfig,
                label: getLangTxt('deviceList'),
                placeholder: getLangTxt('diveListPlaceholder'),
                formType: EnumFormTypes.checkbox,
                defaultValue: [],
            },
            notes: {
                ...baseConfig,
                ...notesConfig,
                label: getLangTxt('notes'),
                placeholder: getLangTxt('notesPlaceholder'),
                maxlength: 200,
                formType: EnumFormTypes.input,
                clearable: false,
                type: EnumFormTypes.inputType
            },
        }
    };
    return config;
};
